import type { RewardBundle } from "./expeditions.js";
import type { Bundle } from "../schema/store.js";

export const OMEGA_ITEM = "itm.omega_core";
/** Total bonuses, not compounding ranks. The core is required for every permanent upgrade. */
export const OMEGA_RANKS = [
  { rank: 1, hq: 6, cost: 1, bonusPct: 8 },
  { rank: 2, hq: 12, cost: 3, bonusPct: 16 },
  { rank: 3, hq: 20, cost: 6, bonusPct: 24 },
] as const;

export const SECTOR_REWARDS: Readonly<Record<string, RewardBundle>> = Object.fromEntries(
  ["north", "east", "south", "west"].map((id, i) => [id, {
    credits: 200 * (i + 1),
    items: [
      { itemId: OMEGA_ITEM, qty: 2 * (i + 1) },
      { itemId: "itm.fab", qty: 10 + i * 5 },
      { itemId: "itm.xp_50000", qty: 2 + i * 2 },
      { itemId: "itm.speedup_build_480", qty: 2 + i },
      { itemId: "itm.crate_aly_10k", qty: 3 * (i + 1) },
    ],
  }]),
);

export interface HqSupply {
  id: string; hq: number; name: { de: string; en: string }; price: number; contents: Bundle;
}
/** Every tier has an earned gift and an independent, once-only Credit offer. No expiry or chain prerequisite. */
export const HQ_SUPPLIES: readonly HqSupply[] = [3, 6, 10, 15, 20, 25, 30].flatMap((hq, i) => {
  const cores = hq < 6 ? [] : [{ itemId: OMEGA_ITEM, qty: i }];
  return [
    { id: `milestone.gift${hq}`, hq, name: { de: `HQ ${hq} · Meilenstein-Geschenk`, en: `HQ ${hq} · Milestone gift` }, price: 0,
      contents: { items: [...cores, { itemId: "itm.fab", qty: 3 + i }, { itemId: "itm.xp_10000", qty: 5 * (i + 1) }] } },
    { id: `milestone.pack${hq}`, hq, name: { de: hq < 6 ? "HQ 3 · Durchbruch" : `HQ ${hq} · OMEGA-Aufstieg`, en: hq < 6 ? "HQ 3 · Breakthrough" : `HQ ${hq} · OMEGA ascent` }, price: [149, 499, 999, 1499, 1999, 2499, 2999][i]!,
      contents: { items: [...cores.map(c => ({ ...c, qty: c.qty + 1 })), { itemId: "itm.fab", qty: 5 * (i + 1) }, { itemId: "itm.xp_50000", qty: 2 * (i + 1) }, { itemId: "itm.speedup_build_480", qty: 2 * (i + 1) }, { itemId: "itm.crate_aly_10k", qty: 5 * (i + 1) }] } },
  ];
});
